import { render, staticRenderFns } from "./CsTag.vue?vue&type=template&id=e47c04f0&"
import script from "./CsTag.vue?vue&type=script&setup=true&lang=js&"
export * from "./CsTag.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports